import React from 'react'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import CategoriesChart from '../categories-chart'
import ColoredCard from '../colored-card'
import prettysize from '../../../utils'
import { Tag } from 'antd'
import './styles.scss'

class S3 extends React.Component {
  constructor(props) {
    super(props)
  }

  loadData = (selectedCloud, onStart, onSuccess, onFail) => {
    onStart()
    CloudFlyerAPI.analytics
      .product(selectedCloud, 'storages')
      .then(({ data }) => {
        const costsSum = data.instances
          .map(item => item.monthly_actual)
          .reduce((a, b) => a + b, 0)
        const chartData = data.instances.map(item => {
          return {
            value: item.monthly_actual,
            name: item.name,
            percent: `${((item.monthly_actual / costsSum) * 100).toFixed(2)}%`,
            cost: `$ ${item.monthly_actual.toFixed(3)}`,
            products: item.products,
          }
        })
        onSuccess(chartData)
      })
      .catch(() => {
        onFail()
      })
  }

  timeoutedLoadData = (selectedCloud, onStart, onSuccess, onFail) => {
    setTimeout(
      () => this.loadData(selectedCloud, onStart, onSuccess, onFail),
      500
    )
  }

  render() {
    const { loading, selectedCloud, s3, efs, transfer, error } = this.props

    let costTotal, sizeTotal
    if (s3.cost || efs.cost || transfer.cost)
      costTotal = (s3.cost || 0) + (efs.cost || 0) + (transfer.cost || 0)

    if (s3.size || efs.size || transfer.size)
      sizeTotal = (s3.size || 0) + (efs.size || 0) + (transfer.size || 0)

    return (
      <div className="s3">
        <div className="side-cards">
          <ColoredCard
            icon="dollar"
            number={costTotal && costTotal.toFixed(2)}
            headerStats={<Tag color="green">{prettysize(sizeTotal)}</Tag>}
            unit="$"
            title={'Total Cost'}
            color={'green'}
            loading={loading}
            error={error}
          />
          <ColoredCard
            icon="dollar"
            number={s3.cost && s3.cost.toFixed(2)}
            headerStats={<Tag color="blue">{prettysize(s3.size)}</Tag>}
            unit="$"
            title={'S3'}
            color={'blue'}
            loading={loading}
            error={error}
          />
          <ColoredCard
            icon="dollar"
            number={efs.cost && efs.cost.toFixed(2)}
            headerStats={<Tag color="orange">{prettysize(efs.size)}</Tag>}
            unit="$"
            title={'EFS'}
            color={'orange'}
            loading={loading}
            error={error}
          />
          <ColoredCard
            icon="dollar"
            number={transfer.cost && transfer.cost.toFixed(2)}
            headerStats={<Tag color="pink">{prettysize(transfer.size)}</Tag>}
            unit="$"
            title={'Transfer'}
            color={'pink'}
            loading={loading}
            error={error}
          />
        </div>
        <CategoriesChart
          selectedCloud={selectedCloud}
          loadData={this.timeoutedLoadData}
        />
      </div>
    )
  }
}

export default S3
